import type React from 'react';
import { memo } from 'react';

import { BusyIcon, isBusyNow, isConfirmed, useSchedule, useTz } from '@entities/schedules';
import cn from 'classnames';

import { getSessionBlock } from '@shared/helpers';

import { StartTime } from '../start-time';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	start: Date;
	end: Date;
	scheduleId: number;
}

export const BusySession: React.FC<Props> = memo(({ start, end, scheduleId, ...props }) => {
	const { schedule } = useSchedule(scheduleId);
	const { tz } = useTz();

	const confirmed = isConfirmed(schedule);

	const isNow = isBusyNow(schedule);

	const blockType = getSessionBlock(
		{
			start,
			end,
		},
		tz,
		schedule?.start_time,
		schedule?.end_time
	);

	return (
		<div
			className={cn(st.busySession, st[blockType], !confirmed && st.unconfirmed, isNow && st.now)}
			{...props}
		>
			{(blockType === 'start' || blockType === 'start_topOverlap' || blockType === 'single') && (
				<>
					<StartTime start={schedule?.start_time} />
					<BusyIcon id={scheduleId} />
				</>
			)}
		</div>
	);
});
